// Application de Twemoji sur le picker emoji (shadow DOM) + messages
// Twemoji.js est chargé depuis CDN comme script classique → window.twemoji

const OPTS = {
    folder: 'svg',
    ext: '.svg',
    base: 'https://cdn.jsdelivr.net/gh/jdecked/twemoji@15/assets/',
    className: 'twemoji',
};

// Applique Twemoji sur un élément (messages, réactions, etc.)
export function applyTwemoji(el) {
    if (el && window.twemoji) window.twemoji.parse(el, OPTS);
}

const SHADOW_CSS = `
img.twemoji {
    width: 1.375em;
    height: 1.375em;
    object-fit: contain;
    vertical-align: -0.15em;
    pointer-events: none;
    display: inline-block;
}
`;

// Installe un MutationObserver sur le shadow root d'un emoji-picker.
// Optimisation clé : on ne re-parse QUE les nœuds nouvellement ajoutés
// (au lieu de tout le shadow DOM à chaque mutation → beaucoup plus léger).
function _observerPicker(picker) {
    if (!picker?.shadowRoot || picker._twemojiReady) return;
    picker._twemojiReady = true;

    // Injecter le CSS une seule fois dans le shadow DOM
    if (!picker.shadowRoot.querySelector('#chaos-twemoji-style')) {
        const style = document.createElement('style');
        style.id = 'chaos-twemoji-style';
        style.textContent = SHADOW_CSS;
        picker.shadowRoot.appendChild(style);
    }

    // File des nœuds à traiter au prochain frame
    const queue = new Set();
    let pending = false;

    const flush = () => {
        if (!window.twemoji) { queue.clear(); pending = false; return; }
        for (const node of queue) {
            if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) {
                window.twemoji.parse(node, OPTS);
            }
        }
        queue.clear();
        pending = false;
    };

    const observer = new MutationObserver(mutations => {
        for (const m of mutations) {
            // Ignorer les mutations causées par notre propre <style>
            for (const node of m.addedNodes) {
                if (node.id === 'chaos-twemoji-style') continue;
                queue.add(node);
            }
        }
        if (!pending && queue.size > 0) {
            pending = true;
            requestAnimationFrame(flush);
        }
    });

    // Premier passage complet sur le shadow DOM déjà rendu
    if (window.twemoji) window.twemoji.parse(picker.shadowRoot, OPTS);

    observer.observe(picker.shadowRoot, { childList: true, subtree: true });
}

// Initialise Twemoji sur tous les emoji-picker de la page.
// Appelé après que le DOM est prêt ET que Twemoji.js est chargé.
export function initTwemojiPickers() {
    if (!window.twemoji) return;
    document.querySelectorAll('emoji-picker').forEach(_observerPicker);
}
